<p class="title-blue mb-16">{{ 'filter_by_date_title' | translate }}</p>
<div class="date-form-field mb-24" (click)="openPicker('from-date')">
  <input type="date" placeholder=" " id="from-date" />
  <label for="from-date" class="text-gray">{{
    'filter_date_from' | translate
  }}</label>
  <!-- <div> {{ filterAccTransactionsForm.get('paymentDateFrom')?.value | transformDate: 'picker' }}   </div> -->
</div>
<div class="date-form-field mb-24" (click)="openPicker('to-date')">
  <input type="date" placeholder=" " id="to-date" />
  <label for="to-date" class="text-gray">{{
    'filter_date_to' | translate
  }}</label>
  <!-- <div> {{ filterAccTransactionsForm.get('paymentDateFrom')?.value | transformDate: 'picker' }}   </div> -->
</div>
<p class="title-blue mb-16">{{ 'account.filterAmountRange' | translate }}</p>
<div fxLayoutAlign="space-between center" class="mb-16">
  <div class="form-field mr-16">
    <input type="text" id="from-amount" placeholder=" " />
    <label for="from-amount">{{ 'filter_amount_from' | translate }}</label>
  </div>
  <div class="form-field">
    <input type="text" id="to-amount" placeholder=" " />
    <label for="to-amount">{{ 'filter_amount_to' | translate }}</label>
  </div>
</div>
<p class="text-gray font-12 mb-34 w-full text-center">
  {{ 'filter_select_range_label' | translate }}
</p>
<p class="title-blue mb-16">{{ 'filter_by_type_title' | translate }}</p>
<div class="select-form-field">
  <select value="0">
    <option value="0">{{ 'filter_all_transactions' | translate }}</option>
    <option value="1">Card</option>
    <option value="2">POS</option>
    <option value="3">Withdrawal</option>
    <option value="4">Exchange</option>
  </select>
  <label>{{ 'filter_type' | translate }}</label>
</div>
<div class="mt-40" fxLayoutAlign="space-between center">
  <lns-button [buttonContent]="cancelButton" (clickEvent)="onBack()"
    >{{ 'general_action_cancel' | translate }}
  </lns-button>
  <lns-button [buttonContent]="applyButton" (clickEvent)="applyFilter()"
    >{{ 'savings_button' | translate }}
  </lns-button>
</div>
